import * as React from 'react';
import './ListErrors.scss';

class ListErrors extends React.Component<any> {
	render() {
		const errors = this.props.errors;
		if (errors) {
			return (
				<ul className="error-list">
				{
					Object.keys(errors).map(key => {
					return (
						<li key={key}>Error: {errors[key]}</li>
					);
					})
				}
				</ul>
			);
		} else {
			return null;
		}
	}
}

export default ListErrors;